export default {
    /**
   * Gets selected blog post
   * @param {Route} to
   * @param {Route} from
   * @param {Function} next
   * @return {*}
   */
    getBlogPOST(to, from, next) {
        if (to.params.entry) {
            next()
        }

        const lang = to.params.lang
        const postName = to.params.title
        let postURL =
            "https://wpress.fernandomt.com/" +
            lang +
            "/wp-json/blog/v1/post?name=" +
            postName

        fetch(postURL)
            .then(r => r.json())
            .then(res => {
                if (res == undefined) {
                    next({ path: lang + '/404' })
                }

                to.params.entry = res
                next()
            })
    },

    /**
   * Removes WP width and height attributes
   * @param {Element} el
   */
    cleanImages(el) {
        var elements = el.querySelectorAll("img")
        elements.forEach((element) => {
          element.removeAttribute("width")
          element.removeAttribute("height")
        })
      }
}
